export default __webpack_public_path__ + "static/media/callraise_0006_thumb.8430433c.jpg";